import isEqual from 'lodash/isEqual';
import isNil from 'lodash/isNil';
import {useEffect, useRef} from 'react';

export default (fn, value) => {
  const prevValue = useRef(null);

  useEffect(() => {
    if (
      (value && prevValue.current && !isEqual(prevValue.current, value))
      || (prevValue.current && isNil(value))
    ) {
      fn();
      prevValue.current = value;
    } else {
      prevValue.current = value;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);
};
